import { X } from "lucide-react";
import { Calculator } from "./Calculator";
import { WorldClock } from "./WorldClock";
import { AgentCalendar } from "./AgentCalendar";

const TITLES = { calculator: "الآلة الحاسبة", calendar: "تقويم المهام", clock: "الساعة والمناطق الزمنية" };

export default function ToolsDrawer({ tool, onClose }) {
  if (!tool) return null;
  return (
    <div className="fixed inset-0 z-40 lg:static lg:inset-auto lg:z-auto" data-testid="tools-drawer">
      <div className="absolute inset-0 bg-black/50 lg:hidden" onClick={onClose} />
      <aside className="absolute left-0 top-0 h-full w-[340px] max-w-[92vw] lg:static lg:h-full bg-[#0B1020] border-r border-white/[0.06] flex flex-col fade-up">
        <div className="h-16 flex items-center justify-between px-4 border-b border-white/[0.06]">
          <p className="font-semibold text-slate-100">{TITLES[tool]}</p>
          <button data-testid="tools-drawer-close" onClick={onClose} className="h-8 w-8 grid place-items-center rounded-lg hover:bg-white/5 text-slate-400"><X size={16} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {tool === "calculator" && <Calculator />}
          {tool === "clock" && <WorldClock />}
          {tool === "calendar" && <AgentCalendar />}
        </div>
      </aside>
    </div>
  );
}
